import * as React from "react";
import { createRoot } from "react-dom/client";
import DecisionTree from "./Components/DecisionTree";

const apiUrl = "/api/DecisionTree/GetQuestion";
const decisionTreeContainerDOM = document.getElementsByClassName("decision-tree-container")[0];

if (decisionTreeContainerDOM) {
    const title = decisionTreeContainerDOM.getAttribute("data-title");
    const id = decisionTreeContainerDOM.getAttribute("data-question");
    const prevBtnText = decisionTreeContainerDOM.getAttribute("data-prevBtnText");
    const nextBtnText = decisionTreeContainerDOM.getAttribute("data-nextBtnText");
    const headingSize = decisionTreeContainerDOM.getAttribute("data-headingSize");

    createRoot(decisionTreeContainerDOM).render(
        <DecisionTree
            title={title}
            apiUrl={apiUrl}
            firstQuestionId={id}
            prevBtnText={prevBtnText}
            nextBtnText={nextBtnText}
            headingSize={headingSize}
        />);
}
